<template>
    <!--
          作者：wangxw
          时间：2019-10-26
          描述：产品分类-添加
      -->
    <el-dialog
      title="编辑物料"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form size="small" :model="form" :rules="formRules" ref="form">
        <el-form-item label="所属分类" :label-width="formLabelWidth">
          <el-select v-model="form.categoryId">
            <!-- <el-option label="顶级分类" value="0"></el-option> -->
            <el-option
              :value="cat.material_id"
              :label="cat.name"
              :key="cat.material_id"
              v-for="cat in addform.catList"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物料名称" prop="name" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="库存" prop="material_stock" :label-width="formLabelWidth">
          <el-input v-model="form.material_stock" autocomplete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item
          label="物料图片"
          prop="imageId"
          :label-width="formLabelWidth"
        >
          <el-row>
            <el-button type="primary" @click="openUpload">选择图片</el-button>
            <div v-if="form.imageId != ''" class="img">
              <img :src="filePath" width="100" height="100" />
            </div>
          </el-row>
        </el-form-item> -->
        <el-form-item label="价格" prop="material_price" :label-width="formLabelWidth">
          <el-input v-model.number="form.material_price" autocomplete="off"></el-input>
        </el-form-item>
      <!-- </el-form> -->
        <el-form-item label="排序" prop="sort" :label-width="formLabelWidth">
          <el-input v-model.number="form.sort" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="addUser" :loading="loading"
          >确 定</el-button
        >
      </div>
      <!--上传图片组件-->
      <Upload
        v-if="isupload"
        :isupload="isupload"
        :type="type"
        @returnImgs="returnImgsFunc"
        >上传图片</Upload
      >
    </el-dialog>
  </template>
  
  <script>
  // import PorductApi from "@/api/product.js";
  import materialApi from "@/api/material.js";
  import Upload from "@/components/file/Upload";
  export default {
    components: {
      Upload
    },
    data() {
      return {
        form: {
          categoryId: "",
          name: "",
          sort: 100,
          material_stock:'',
          material_price:'',
          sales_actual:0
          // imageId: ""
        },
        formRules: {
          name: [
            {
              required: true,
              message: "请输入物料名称",
              trigger: "blur"
            }
          ],
          sort: [
            {
              required: true,
              message: "物料排序不能为空"
            },
            {
              type: "number",
              message: "物料排序必须为数字"
            }
          ]
        },
        /*左边长度*/
        formLabelWidth: "120px",
        /*是否显示*/
        dialogVisible: false,
        loading: false,
        /*是否上传图片*/
        isupload: false
      };
    },
    props: ["open_add1", "addform",'material_id'],
    created() {
      this.dialogVisible = this.open_add1;
      console.log(this.material_id)
    //   this.material_id=
      this.getdetail(this.material_id)
    },
    methods: {
        getdetail(e){
            let self=this
            materialApi.materialdetail({
                material_id:e
            },true).then(res=>{
                let aform=res.data.detail
                // let form=self.form
            //   console.log(form)
              self.form.categoryId=aform.categoryId
              self.form.name=aform.name
              self.form.material_stock=aform.material_stock
              self.form.material_price=aform.material_price
              self.form.sort=aform.productSort
              self.form.material_id=aform.material_id
              if(aform.sales_actual){
                self.sales_actual=aform.sales_actual
              }
            })   
            },
      /*添加物料*/
      addUser() {
        let self = this;
        let params = self.form;
        console.log(params)
        self.$refs.form.validate(valid => {
          if (valid) {
            self.loading = true;
            materialApi.editProduct(params)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: "编辑成功",
                  type: "success"
                });
                self.dialogFormVisible(true);
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
  
      /*关闭弹窗*/
      dialogFormVisible(e) {
          this.$emit("closeDialog", {
            type: "success",
            openDialog: false
          });
      
      },
      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.filePath = e[0].filePath;
          this.form.imageId = e[0].fileId;
        }
        this.isupload = false;
      }
    }
  };
  </script>
  
  <style>
  .img {
    margin-top: 10px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/agent/agent/edit.vue